var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.674927,
    y: 0.5625,
    width: 63.99,
    height: 63.99,
    rx: 16,
    fill: "white",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.0032 31.3301V32.5568C46.0016 35.432 45.0706 38.2297 43.349 40.5326C41.6274 42.8354 39.2076 44.5201 36.4504 45.3353C33.6931 46.1505 30.7462 46.0527 28.0492 45.0562C25.3521 44.0598 23.0494 42.2183 21.4845 39.8062C19.9196 37.3942 19.1763 34.5409 19.3655 31.6719C19.5546 28.8029 20.6662 26.0719 22.5343 23.8862C24.4024 21.7005 26.9269 20.1773 29.7315 19.5436C32.536 18.91 35.4702 19.1999 38.0966 20.3701",
    stroke: "#F8F8F8",
    strokeWidth: 2.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6699 31.224L32.6699 35.224L46.0033 21.8906",
    stroke: "#F8F8F8",
    strokeWidth: 2.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarker);
export default __webpack_public_path__ + "static/media/checkmarker.cf125b7fd6955c54d503fd5d88572912.svg";
export { ForwardRef as ReactComponent };